import { render, staticRenderFns } from "./DefaultEditComplete.vue?vue&type=template&id=1aa04820&lang=pug&"
import script from "./DefaultEditComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultEditComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports